// extracted by mini-css-extract-plugin
export default {"modal":"Ax","topline":"Bx","img":"Cx","textcontents":"Ex","heading":"Fx","copy":"Gx","link":"Hx","close":"Ix","modalinner":"Jx","container":"Kx"};
    if(module.hot) {
      // 1715632475062
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  